
    var riot = require('riot')
    //src: starling/src/tags/site-previewer.html
riot.tag2('site-previewer',
  '<loading if="{isLoading()}"></loading> <site-previewer-item if="{!isLoading()}" each="{getLoadedSites()}" canvas="{parent.opts.canvas}" nodetag="{parent.parent}"></site-previewer-item>',
  '',
  'class="site-previewer_container {site-previewer_container--loading: isLoading()}"', function(opts) {
'use strict';

var _this = this;

var _sitePreviewUi = require('lib/site-preview-ui');

var _opts = opts,
    canvas = _opts.canvas;
var operation = canvas.operation;

this.getSitesToLoad = function () {
  var urlPreviews = _sitePreviewUi.spUI.urlPreviews;

  return opts.sites.filter(function (url) {
    return !urlPreviews.hasOwnProperty(url);
  });
};

this.on('mount', function () {
  _this.loadSites();
});

this.on('update', function () {
  _this.loadSites();
});

this.isLoading = function () {
  return _this.getSitesToLoad().length;
};

this.getLoadedSites = function () {
  var urlPreviews = _sitePreviewUi.spUI.urlPreviews;

  return Array.from(new Set(_this.opts.sites.filter(function (url) {
    return urlPreviews[url];
  }).map(function (url) {
    return urlPreviews[url];
  }).filter(function (_ref) {
    var isBroken = _ref.isBroken,
        isHidden = _ref.isHidden;
    return !isHidden && !isBroken;
  })));
};

this.loadSites = function () {
  var urls = _this.getSitesToLoad();
  var urlPreviews = _sitePreviewUi.spUI.urlPreviews;

  if (!urls.length) return;

  $.ajax({
    url: '/api/maps/internal_link_previews',
    method: 'POST',
    data: {
      urls: urls
    },
    success: function success(_ref2) {
      var result = _ref2.result;

      if (result && result.length) {
        result.forEach(function (data) {
          return urlPreviews[data.url] = data;
        });
        _this.update();
      } else {
        urls.forEach(function (url) {
          return urlPreviews[url] = { url: url, isBroken: true };
        });
        _this.update();
      }
    },
    failure: function failure(res) {
      urls.forEach(function (url) {
        return urlPreviews[url] = { url: url, isBroken: true };
      });
      _this.update();
    }
  });
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('site-previewer')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/site-previewer.html
// module id = 739
// module chunks = 0